var map = {
	"./home-box1-bg-light.png": "c02b",
	"./home-box1-sandbox-light.png": "21ef",
	"./home-customer-choice-light.png": "f7b8",
	"./home-huawei-light.png": "d8d6",
	"./home-meituan-light.png": "9789",
	"./home-midea-light.png": "0891",
	"./home-prc-light.png": "95f9",
	"./home-product-advantage-light.png": "20bb",
	"./home-scdx-light.png": "59eb",
	"./home-selected-report-light.png": "9ea4",
	"./home-service-price-light.png": "c46c",
	"./home-servicePrice-mf-light.png": "fe02",
	"./home-servicePrice-qy-light.png": "71a7",
	"./home-servicePrice-zy-light.png": "4ab5",
	"./home-servicePrice-zyzq-light.png": "e419",
	"./home-typical-scenarios-light.png": "a6a8",
	"./home-wz-light.png": "bd47",
	"./home-yjzx-light.png": "1452",
	"./home-zggs-light.png": "1c6d",
	"./home-zgyd-light.png": "dfdc",
	"./home-zhaoshang-light.png": "2065"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ff09";